import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
// import {getUrlParameters} from '../../../common/util/urlParameters';
// import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsAreas = () => apiActionCreator({
  'endpoint': '/wts/catalog/areas',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AREAS,
    ActionTypes.FETCHED_WTS_AREAS,
    [
      ActionTypes.FETCHED_WTS_AREAS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeWtsAreaSelected = (areaSelected) => ({
  'type': ActionTypes.CHANGE_WTS_AREA_SELECTED,
  'payload': areaSelected,
});

export const clearWtsAreas = () => ({'type': ActionTypes.CLEAR_WTS_AREAS});
